import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { RobotoTypo } from '../../../utils/Typographies';
import axios from 'axios';
import ConsultationCard from './ConsultationCard';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function ConsultationMain() {

  const [activitiesList, setActivitiesList] = useState([]);
  const language = useSelector((state) => state.language.language);
  const path = useLocation()
  const {t} = useTranslation()
  console.log(`${path.pathname}.title`, 'path');
const baseKey = path.pathname;

  const sampleData = {
    onlineConsultation : {
      title : "Singapore Study Online Consultation",
      description : "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur.Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione volunteer sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, co"
    }
  }

  const fetchActivitiy = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/get-consultations-by-category${path.pathname}`
      );
      
      if (response.data.success) {
        
        setActivitiesList(response.data.data);
      }
    } catch (error) {
      console.log("Error fetching activities", error);
      setActivitiesList([]);
    }
  }

  useEffect(() => {
    fetchActivitiy();
  }, [path.pathname]);

  console.log(activitiesList, 'act');

  return (
    <>
    <Box sx={{padding : '5% 8%'}}>

        <Box>
          <RobotoTypo style={{ fontSize : '28px', color : '#003B5C', fontWeight : 700 }}>{t(`${baseKey}.title`, {returnObjects : true})}</RobotoTypo>
          <RobotoTypo style={{marginTop : '18px', color : '#242424', fontWeight : 400, fontSize : '20px'}}>{t(`${baseKey}.description`, {returnObjects : true})}</RobotoTypo>
        </Box>

        <Box style={{mt : '100px'}}>

        </Box>
    </Box>
    
    <Box sx={{backgroundColor : "#F7F7F7", padding : '5% 8%'}}>

      <Box sx={{display : 'flex', justifyContent : 'center'}}>
        <Box sx={{width : '40dvh', display : 'flex', justifyContent : 'center',backgroundColor : "#183265", borderRadius : '50px'}}>
            <RobotoTypo style={{fontSize : '24px', fontWeight : 700,  padding : '6px 18px',  color : 'white'}}>{t('Activities')}</RobotoTypo>
        </Box>

        
        
      </Box>

      <Box>
        <Box sx={{display : 'flex', flexWrap : 'wrap', gap : '60px', justifyContent : 'flex-start', marginTop : '40px'}}>
          {activitiesList.map((activity, index) => (
            <ConsultationCard 
            key={index} 
            activity={activity}
            image={activity.bannerImage} 
            title={activity.title} 
            description={activity.description} 
            Date={new Date(activity.date).toLocaleDateString()} 
            tags={activity?.tags?.[language] || []}
            />  
          ))}
        </Box>
      </Box>

    </Box>
    </>
  )
}

export default ConsultationMain;